import { ErrorMessage, Rule } from '~domain/model/core/validation/rule';
import { BaseValidator } from '~domain/validators/core/base-validator';
import { NumberValidator } from '~domain/validators/core/basic-types/number-validator';

export class LongitudeValidator extends BaseValidator<number> {
  protected rules: Rule<number>[] = [this.createNullRule(), this.validateContent];

  // Longitude must be between -180 and 180
  private numberValidator: NumberValidator = new NumberValidator(-180, 180, 'validation.error.longitude');

  private validateContent(value: number): ErrorMessage {
    return this.numberValidator.validate(value);
  }
}
